// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__2TY5a","tab__body":"styles_tab__body__3JmT2","tab__arrow":"styles_tab__arrow__10Sy9","tab__content":"styles_tab__content__1Dtxx"};